export default __webpack_public_path__ + "static/media/discount.ee3db9ce.png";